<template>
  <div>
    <PerfectScrollbar class="AllPwaMobile">
      <div>
        <div class="WalletAllPwaMobile">
          <VsxIcon @click="ShowBtnModel" iconName="AddSquare" :size="32" :color="color" type="linear" />

          <p>{{ $t('ticket.title') }}</p>
        </div>
        <div class="TableModelShowIconToUserSpan1">
          <div class="TopShiwRowModel">
            <div class="ChildTopShiwRowModel">{{ $t('ticket.settings') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('ticket.priority') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('ticket.status') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('ticket.subject') }}</div>
          </div>

          <div v-for="(typeList, index) in listResponse" :key="index" class="TopShiwRowModel">
            <div style="display: grid; justify-content: center; grid-gap: 10px; grid-template-columns: auto auto; align-items: center" class="ChildTopShiwRowModel1">
              <router-link :to="{ name: 'seeTicket', params: { id: typeList.id } }">
                <div style="background: #D8B9FF" class="BtnEditC">{{ $t('ticket.chat') }}</div>
              </router-link>
            </div>
            <div class="ChildTopShiwRowModel1">
              <span style="font-size: .8rem" v-if="typeList.priority == '1'">{{ $t('ticket.priorities.low') }}</span>
              <span style="font-size: .8rem" v-if="typeList.priority == '2'">{{ $t('ticket.priorities.medium') }}</span>
              <span style="font-size: .8rem" v-if="typeList.priority == '3'">{{ $t('ticket.priorities.high') }}</span>
            </div>
            <div class="ChildTopShiwRowModel1">
              <span style="font-size: .8rem" v-if="typeList.status == 0">{{ $t('ticket.statuses.open') }}</span>
              <span style="font-size: .8rem" v-if="typeList.status == 1">{{ $t('ticket.statuses.sent') }}</span>
              <span style="font-size: .8rem" v-if="typeList.status == 2">{{ $t('ticket.statuses.hasMessage') }}</span>
              <span style="font-size: .8rem" v-if="typeList.status == 3">{{ $t('ticket.statuses.closed') }}</span>
            </div>
            <div style="padding-top: 8px" class="ChildTopShiwRowModel1">
              <VsxIcon @click="FunClick(typeList.subject , typeList.ticket)" iconName="Eye" :size="32" :color="color" type="linear" />
            </div>
          </div>

        </div>
      </div>

      <div @click="modelShow = false" v-if="modelShow" class="ModelShowIconToUserSpan">
        <div @click.stop class="TableModelShowIconToUserSpan2">
          <form>
            <div style="display: grid; grid-template-columns: 50% 50%; justify-content: space-between">
              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('ticket.create.email') }}</label>

                <div class="ShowAllNavBarStatus">
                  <input autocomplete="off" v-model="email" type="text" name="username">
                </div>

              </div>
              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('ticket.create.name') }}</label>

                <div class="ShowAllNavBarStatus">
                  <input v-model="name" autocomplete="off" type="text" name="name">
                </div>

              </div>

              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('ticket.create.priority') }}</label>

                <div class="ShowAllNavBarStatus">
                  <select v-model="priority">
                    <option value="1">{{ $t('ticket.priorities.low') }}</option>
                    <option value="2">{{ $t('ticket.priorities.medium') }}</option>
                    <option value="3">{{ $t('ticket.priorities.high') }}</option>
                  </select>
                </div>

              </div>
              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('ticket.create.subject') }}</label>

                <div class="ShowAllNavBarStatus">
                  <input autocomplete="off"  v-model="subject" type="text" name="username">
                </div>

              </div>
            </div>

            <div class="ShowLogoInputAndLAbel">
              <label>{{ $t('ticket.create.message') }}</label>

              <div class="ShowAllNavBarStatus">
                <textarea v-model="message"></textarea>
              </div>

            </div>

            <div @click="CreateTicket" class="ShowLogoInputAndLAbel23">
              {{ $t('ticket.create.submit') }}
            </div>
          </form>
        </div>
      </div>

    </PerfectScrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import axios from "@/axios";
import {toast} from "vue3-toastify";

export default {
  name: "TicketUserComponent",
  components: {
    PerfectScrollbar,
  },
  data(){
    return{
      radios1:'dollar',
      modelShow: false,
      modelShowE: false,

      name: '',
      email: '',
      subject: '',
      priority: '',
      message: '',

      siteBank: [],
      myBank: [],
      listResponse: [],
      editList: [],

      value2: {name: 'آدرس کیف پول مقصد را انتخاب کنید'},
      option2: [

      ],
    }
  },
  mounted() {
    this.getListResponse()
    setInterval(() => {
      this.loadTheme()
    }, 100);
  },
  methods:{
    async FunClick(value , value1){
      await this.$swal({
        title: `${value} ${value1}`,
        showCancelButton: false,
      });
    },
    ShowBtnModel(){
      this.modelShow =! this.modelShow
    },
    async CreateTicket(){
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      if(this.radios1 == 'dollar'){
        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;
        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/create-ticket' , {
              user_id : userData1.id,
              name : this.name,
              email : this.email,
              subject : this.subject,
              priority : this.priority,
              message : this.message,
            });

            if (response.data[0] == "success"){
              toast(" تیکت شما با موفقیت ثبت شد. ", {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
              this.getListResponse()
              this.modelShow = false
              this.subject = ''
              this.priority = ''
              this.message = ''
            }

            return;
          } catch (error) {
            if (error.response) {
              const errors = error.response.data.errors;

              const keys = Object.keys(errors);
              for (const key of keys) {
                toast(errors[key].join(', '), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }
              return;
            } else {
              console.error('An unexpected error occurred:', error.message);
              toast("یک خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }

    },
    async getListResponse(){
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      this.name = (userData1.firstname + ' ' + userData1.lastname)
      this.email = userData1.email

      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;
      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/get-supports' , {
            id : userData1.id,
          });

          this.listResponse = response.data

          return;
        } catch (error) {
          console.log('error')
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    },
    async deleteBtn(value){
      const result = await this.$swal({
        title: 'آیا مطمئن هستید؟',
        text: "این عمل قابل بازگشت نیست",
        showCancelButton: true,
        confirmButtonText: 'حذف',
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: 'انصراف',
        cancelButtonAriaLabel: "Thumbs down"
      });

      if (result.value == true) {

        const userData = localStorage.getItem('user');
        const userData1 = JSON.parse(userData);

        if(this.radios1 == 'dollar'){
          let attempts = 0;
          const maxAttempts = 10;
          const delay = 100;
          while (attempts < maxAttempts) {
            try {
              const responsive = await axios.post('/delete-wallet' , {
                user_id : userData1.id,
                wallet_id : value.id,
              });

              if (responsive.data == "success"){
                this.getListResponse()
                toast(" کیف پول شما حذف شد. ", {
                  autoClose: 3000,
                  position: "top-right",
                  type: "success",
                });
              }else{
                toast("  کیف پول حذف نشد . ", {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }

              return;
            } catch (error) {
              console.log('error')
            }

            attempts++;
            await new Promise(resolve => setTimeout(resolve, delay));
          }
        }

        if(this.radios1 == 'rial'){
          let attempts = 0;
          const maxAttempts = 10;
          const delay = 100;
          while (attempts < maxAttempts) {
            try {
              const responsive = await axios.post('/delete-bank' , {
                user_id : userData1.id,
                id : value.id,
              });

              if (responsive.data[0] == 'success'){
                this.getListResponse()
                toast(" حساب بانکی حذف شد. ", {
                  autoClose: 3000,
                  position: "top-right",
                  type: "success",
                });
              }else{
                toast("  حساب بانکی حذف نشد . ", {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }

              return;
            } catch (error) {
              console.log('error')
            }

            attempts++;
            await new Promise(resolve => setTimeout(resolve, delay));
          }
        }
      }
    },
    async btnUpdate(){
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      if(this.radios1 == 'dollar'){
        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;
        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/edit-wallet' , {
              user_id : userData1.id,
              id : this.editList.id,
              name : this.nameE,
              network : this.networkE,
              address : this.addressE,
            });

            if (response.data == "success"){
              toast(" کیف پول شما ویرایش شد . ", {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
              this.getListResponse()
              this.modelShowE = false
            }

            return;
          } catch (error) {
            if (error.response) {
              const errors = error.response.data.errors;

              const keys = Object.keys(errors);
              for (const key of keys) {
                toast(errors[key].join(', '), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }
              return;
            } else {
              console.error('An unexpected error occurred:', error.message);
              toast("یک خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }

      if(this.radios1 == 'rial'){
        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;
        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/edit-bank' , {
              user_id : userData1.id,
              id : this.editList.id,
              name : this.value2.name,
              bank_id : this.value2.all,
              shaba_number : this.addressE,
              card_number : this.networkE,
            });

            if (response.data[0] == 'success'){
              toast("حساب شما ویرایش شد . ", {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
              this.getListResponse()
              this.modelShowE = false
            }

            return;
          } catch (error) {
            if (error.response) {
              const errors = error.response.data.errors;

              const keys = Object.keys(errors);
              for (const key of keys) {
                toast(errors[key].join(', '), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }
              return;
            } else {
              console.error('An unexpected error occurred:', error.message);
              toast("یک خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if( savedTheme == "light"){
        this.color = '#2E1977'
      }else{
        this.color = '#BB86FC'
      }
    }
  },
}
</script>

<style scoped>
.ShowLogoInputAndLAbel{
  grid-gap: 10px !important;
}
.ShowAllNavBarStatus input{
  border-radius: 5px !important;
  background: #D3C5FF7A !important;
}
.TopShiwRowModel{
  display: grid;
  grid-template-columns: 25% 25% 25% 25% !important;
}
.MenuAllSiteHeaderMenuDeposit{
  justify-content: center !important;
}
.ShowAllNavBarStatus select{
  background: #D3C5FF7A !important;
  border-radius: 5px !important;
}
</style>